import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { marketingPreference } from '@kfc-global/react-shared/redux/Actions/OrderservAction';
import { ButtonComp } from 'atoms/Buttons';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCommunicationPreferencesAnalytics } from '../accountPageUtils';
import { COMMUNICATION_PREFERENCES_CONSTANTS } from '../Constants/Constants';

const CommunicationPreferencesCard = ({ communicationPreferences, basicData, tenantId }) => {
  const { COMMUNICATION_PREFERENCES_TEXT, SAVE } = COMMUNICATION_PREFERENCES_CONSTANTS;
  const marketingConfigData = useSelector(data => data.marketConfigReducer.response || null);
  const [preferences, setPreferences] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    let tempCommunicationPrefData = [];
    marketingConfigData?.headerData?.communicationPreferences?.forEach(item => {
      tempCommunicationPrefData.push({
        mainText: item.fields?.value,
        subText: item.fields?.subValue,
        checked: !!communicationPreferences?.find(pref => pref === item.fields?.code),
        code: item?.fields?.code,
      });
    });
    if (basicData?.marketingPreferences?.length > 0) {
      setPreferences(
        tempCommunicationPrefData.map(item => {
          if (basicData.marketingPreferences.find(code => code === item.code)) {
            return { ...item, checked: true };
          }
          return item;
        }),
      );
    } else {
      setPreferences(tempCommunicationPrefData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketingConfigData?.headerData?.communicationPreferences?.length]);

  const handleCheckbox = e => {
    const temp = preferences.map(item => {
      if (item.code === e.target.value) {
        return { ...item, checked: !item.checked };
      }
      return item;
    });
    setPreferences(temp);
  };

  const saveCommunicationPreferences = () => {
    let selectedPreferences = [];
    preferences.forEach(item => {
      if (item.checked) {
        return selectedPreferences.push(item.code);
      }
    });
    // analytics for saving preferences
    updateCommunicationPreferencesAnalytics(selectedPreferences);
    dispatch(
      marketingPreference({
        tenantId,
        customerId: basicData?.id,
        phoneNumber: basicData?.phone,
        body: { marketingPreferences: selectedPreferences },
      }),
    );
  };

  return (
    // (preferences.length > 0 &&
    <div className='preferences-card'>
      <div className='preferences-card-left-side'>{translateWithI18Next(COMMUNICATION_PREFERENCES_TEXT)}</div>
      <div className='preferences-card-right-side'>
        <p>Colonels Club</p>
        <p>(member since 2016)</p>
        <div className='horizontal-line-club'></div>

        <div className='preferences-container'>
          <ul className='preferences-item'>
            {preferences?.map(item => (
              <li key={item.code} className='preferences-item-list'>
                <input
                  id={item.code}
                  type='checkbox'
                  value={item.code}
                  checked={item.checked}
                  data-testid={`communication-preferences-${item.mainText}-test`}
                  onChange={handleCheckbox}
                />
                <div className='preferences-text'>
                  <label htmlFor={item.mainText}>{item.mainText}</label>
                  {item.subText !== '' && <span className='preference-subText'>{item.subText}</span>}
                </div>
              </li>
            ))}
          </ul>
        </div>
        <ButtonComp
          className='save-account-button'
          data-testid='save-communication-preferences'
          onClickHandler={saveCommunicationPreferences}
        >
          {translateWithI18Next(SAVE)}
        </ButtonComp>
      </div>
    </div>
    // )
  );
};
export default CommunicationPreferencesCard;
